export enum Permission {
  USERS_READ = "users.read",
  USERS_CREATE = "users.create",
  USERS_UPDATE = "users.update",
  USERS_DELETE = "users.delete",

  ADMINS_READ = "admins.read",
  ADMINS_CREATE = "admins.create",
  ADMINS_UPDATE = "admins.update",
  ADMINS_DELETE = "admins.delete",

  ROLES_READ = "roles.read",
  ROLES_CREATE = "roles.create",
  ROLES_UPDATE = "roles.update",
  ROLES_DELETE = "roles.delete",

  SYSTEM_SETTINGS_READ = "system.settings.read",
  SYSTEM_SETTINGS_UPDATE = "system.settings.update",

  AUDIT_LOGS_READ = "audit_logs.read",
  // Notifications
  ADMIN_NOTIFICATIONS_READ = "admin_notifications.read",
  ADMIN_NOTIFICATIONS_UPDATE = "admin_notifications.update",
  USER_NOTIFICATIONS_READ = "user_notifications.read",
  USER_NOTIFICATIONS_UPDATE = "user_notifications.update",
  USER_NOTIFICATIONS_CREATE = "user_notifications.create",

  // Dashboard
  DASHBOARD_READ = "dashboard.read",

  // Background Tasks
  BACKGROUND_TASKS_READ = "background_tasks.read",

  // Marketplace
  LISTINGS_READ = "listings.read",
  LISTINGS_IMPORT = "listings.import",
  BOOKINGS_READ = "bookings.read",
  USERS_VERIFICATION = "users.verification",

  // Finance
  FINANCE_READ = "finance.read",
  FINANCE_UPDATE = "finance.update",
  POINTS_HISTORY_READ = "points.history.read",

  // Charter Destinations
  CHARTER_DESTINATIONS_READ = "charter.destinations.read",
  CHARTER_DESTINATIONS_CREATE = "charter.destinations.create",
  CHARTER_DESTINATIONS_UPDATE = "charter.destinations.update",
  CHARTER_DESTINATIONS_DELETE = "charter.destinations.delete",
}
